/**
 * @file useFetchPolling
 * @author dailin01
 */

import {isFunction} from 'lodash';
import useFetch from '../../biz/fetch';
import {useEffect, useRef} from 'react';

export default <TParam, TData>(
    action: (params?: any) => Promise<TData>,
    params?: TParam,
    $onRequest?: (payload?: any) => any,
    $onResponse?: (result?: any, params?: any) => any,
    $onError?: (ex: any) => void,
    abort?: boolean,
    interval?: number
) => {
    const stopRef = useRef(false);
    const resultRef = useRef<any>({});

    const result = useFetch(
        action,
        params,
        $onRequest,
        res => {
            isFunction($onResponse) && $onResponse(res);
            if (!stopRef.current) {
                setTimeout(resultRef.current.reload, interval || 0);
            }
        },
        $onError,
        abort
    );
    resultRef.current = result;

    useEffect(() => () => {
        stopRef.current = true;
    }, []);

    return result;
};